import React, { useState } from "react";
import { Card, Button } from "@themesberg/react-bootstrap";

const CustomCalendar = () => {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
  const daysInMonth = getDaysInMonth(currentMonth, currentYear);

  const changeMonth = (offset) => {
    let newMonth = currentMonth + offset;
    let newYear = currentYear;
    if (newMonth < 0) {
      newMonth = 11;
      newYear -= 1;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear += 1;
    }
    setCurrentMonth(newMonth);
    setCurrentYear(newYear);
  };

  const calendarCells = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    calendarCells.push(<div key={`empty-${i}`} className="p-2"></div>);
  }
  for (let day = 1; day <= daysInMonth; day++) {
    const isToday =
      day === today.getDate() &&
      currentMonth === today.getMonth() &&
      currentYear === today.getFullYear();
    calendarCells.push(
      <div
        key={day}
        className={`text-center rounded border shadow-sm p-2 m-1`}
        style={{
          backgroundColor: isToday ? "#05a07eff" : "#fff",
          color: isToday ? "#fff" : "#333",
          fontWeight: isToday ? "bold" : "normal",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          if (!isToday) e.currentTarget.style.backgroundColor = "#f1f3f5";
        }}
        onMouseLeave={(e) => {
          if (!isToday) e.currentTarget.style.backgroundColor = "#fff";
        }}
      >
        {day}
      </div>
    );
  }

  return (
    <Card className="shadow-sm border-0">
      {/* Header */}
      <Card.Header className="d-flex justify-content-between align-items-center bg-light">
        <Button size="sm"  style={{ backgroundColor: "#05a07e", borderColor: "#05a07e", color: "white" }} onClick={() => changeMonth(-1)}>◀</Button>
        <h6 className="m-0 fw-bold text-primary">
          {monthNames[currentMonth]} {currentYear}
        </h6>
        <Button size="sm"  style={{ backgroundColor: "#05a07e", borderColor: "#05a07e", color: "white" }} onClick={() => changeMonth(1)}>▶</Button>
      </Card.Header>

      {/* Calendar Body */}
      <Card.Body>
        <div
          className="d-grid"
          style={{
            gridTemplateColumns: "repeat(7, 1fr)",
            gap: "5px",
            textAlign: "center",
          }}
        >
          {daysOfWeek.map((d) => (
            <div key={d} className="fw-bold text-muted">{d}</div>
          ))}
          {calendarCells}
        </div>
      </Card.Body>
    </Card>
  );
};

export default CustomCalendar;
